var render, staticRenderFns
import script from "./dynamicForm.vue?vue&type=script&lang=js&"
export * from "./dynamicForm.vue?vue&type=script&lang=js&"
import style0 from "./dynamicForm.vue?vue&type=style&index=0&id=3d9e7073&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9e7073",
  null
  
)

export default component.exports